import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Testimonials = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      id: 1,
      name: "María González",
      location: "Miami, FL",
      image: "https://images.pexels.com/photos/3586966/pexels-photo-3586966.jpeg?auto=compress&cs=tinysrgb&w=300",
      rating: 5,
      textKey: "testimonials.testimonial1",
      productKey: "categories.detoxTitle"
    },
    {
      id: 2,
      name: "Ana Rodríguez",
      location: "Los Angeles, CA",
      image: "https://images.pexels.com/photos/3765550/pexels-photo-3765550.jpeg?auto=compress&cs=tinysrgb&w=300",
      rating: 5,
      textKey: "testimonials.testimonial2",
      productKey: "categories.weightLossTitle"
    },
    {
      id: 3,
      name: "Carmen Silva",
      location: "Houston, TX",
      image: "/images/hero-fitness.jpg",
      rating: 5,
      textKey: "testimonials.testimonial3",
      productKey: "categories.fiberTitle"
    },
    {
      id: 4,
      name: "Isabella Morales",
      location: "Phoenix, AZ",
      image: "https://images.pexels.com/photos/3812944/pexels-photo-3812944.jpeg?auto=compress&cs=tinysrgb&w=300",
      rating: 5,
      textKey: "testimonials.testimonial4",
      productKey: "categories.packsTitle"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-pink-50 via-white to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            {t('testimonials.title')}
            <span className="bg-gradient-to-r from-[#4ECDC4] to-[#95C11F] bg-clip-text text-transparent">
              {' '}
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 transform hover:-translate-y-1"
            >
              {/* Quote Icon */}
              <div className="flex justify-center mb-4">
                <div className="bg-gradient-to-r from-[#4ECDC4] to-[#95C11F] p-3 rounded-full">
                  <Quote className="w-6 h-6 text-white" />
                </div>
              </div>

              {/* Rating */}
              <div className="flex justify-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                ))}
              </div>

              {/* Testimonial Text - AQUI ESTÁ A MUDANÇA PRINCIPAL */}
              <p className="text-gray-700 text-center mb-6 leading-relaxed">
                "{t(testimonial.textKey)}"
              </p>

              {/* Product */}
              <div className="bg-gradient-to-r from-[#4ECDC4] to-[#95C11F] bg-opacity-10 rounded-lg p-3 mb-4">
                <p className="text-sm font-medium text-[#4ECDC4] text-center">
                  {t('testimonials.product')}: {t(testimonial.productKey)}
                </p>
              </div>

              {/* Customer Info */}
              <div className="flex items-center justify-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-3"
                />
                <div className="text-center">
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16 bg-white rounded-3xl shadow-lg p-8 lg:p-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-[#4ECDC4] mb-2">15,000+</div>
              <p className="text-gray-600 font-medium">{t('stats.customers')}</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#95C11F] mb-2">4.9★</div>
              <p className="text-gray-600 font-medium">{t('stats.rating')}</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#4ECDC4] mb-2">98%</div>
              <p className="text-gray-600 font-medium">{t('stats.recommend')}</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#95C11F] mb-2">3</div>
              <p className="text-gray-600 font-medium">{t('stats.years')}</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button className="bg-gradient-to-r from-[#4ECDC4] to-[#95C11F] text-white px-8 py-4 rounded-full font-bold text-lg hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200">
            {t('newsletter.joinTitle')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
